import React from 'react';
import { Row, Button } from 'react-bootstrap';

import Loading from '../../components/Loading';

export default function LoadMoreButton(props){
  if (props.loading) { return <Loading />}
  if (props.userCount > 0) {
    return (
      <Row className="show-grid" style={{textAlign: 'center'}}>
        <Button onClick={props.loadMore}>
          Load More
        </Button>
      </Row>
    );
  }
  return null;
}
